import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Typography,
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  Button,
  ListItem,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  MealName,
  MealNameToOrder,
  MenuItem,
  ModalNames,
  Recipe,
  State,
  StateProps,
} from "../state";
import { openMealCard } from "../MealDisplay";
import { loadRecipes, saveState } from "../../api";
import { localStorageEmailKey, localStorageRecipeKey } from "../../App";
import { toggleModal } from "./Modal";
import { ExpandableListProps } from "./RecipeBookModal";

export function ConfirmationModal(props: StateProps) {
  useEffect(() => {}, []);

  const { state, setState } = props;
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "95%",
        height: "80%",
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 24,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          px: 3,
          pb: 2,
        }}
      >
        <Box mt={2}>
          <Typography display="block" variant="subtitle1" fontWeight="bold">
            Are you sure you want to clear the shopping list?
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          p: 2,
          borderTop: "1px solid",
          borderColor: "divider",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            setState((prevState: State) => {
              const newState = {
                ...prevState,
                additionalItems: [],
                menu: {},
                shoppingList: [],
                itemsInCart: undefined,
              };
              const email = localStorage.getItem(localStorageEmailKey);
              if (email) {
                saveState({ state: newState, email, forceSave: true });
              }
              toggleModal({ setState, name: ModalNames.CONFIRMATION });
              return newState;
            });
          }}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
}
/*
// TODO - why was this duplicated?
export interface ExpandableListProps extends StateProps {
  recipes: Record<string, Recipe>;
  readonly expanded: boolean;
  readonly setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

export function CustomRecipe(props: ExpandableListProps) {
  const [customRecipeState, setCustomRecipeState] = useState({
    meal: "",
  });
  const { expanded, setExpanded, state, setState } = props;
  return (
    <Box mt={3}>
      <ListItemButton onClick={() => setExpanded(!expanded)}>
        <ListItemText primary="Custom Recipe" />
        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {Object.keys(customRecipeState).map((k) => {
          return (
            <TextField
              fullWidth
              multiline={k === "meal" ? true : false}
              rows={4}
              sx={{ display: "block" }}
              id="outlined-basic"
              label={k}
              value={customRecipeState[k as keyof typeof customRecipeState]}
              onChange={(e) => {
                setCustomRecipeState((prevCustomRecipe) => {
                  return {
                    ...prevCustomRecipe,
                    [k as keyof typeof customRecipeState]: e.target.value,
                  };
                });
              }}
              variant="outlined"
            />
          );
        })}
        <Button
          onClick={() => {
            const customRecipe: Recipe = {
              instructions: [
                {
                  instructions: [
                    ...customRecipeState.meal.toLocaleLowerCase().split("\n"),
                  ].filter((val): val is string => val.trim() !== ""),
                },
              ],
              name: `custom ${state.selectedMealName}`,
            };
            onClick({ item: customRecipe, setState, state });
          }}
          variant="outlined"
        >
          Submit
        </Button>
      </Collapse>
    </Box>
  );
}
*/

export function expandableList(props: ExpandableListProps) {
  const { expanded, setExpanded, state, setState } = props;
  return (
    <Box mt={3}>
      <ListItemButton onClick={() => setExpanded(!expanded)}>
        <ListItemText primary="Recipes" />
        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List
          dense
          sx={{
            maxHeight: 200,
            overflowY: "auto",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          {Object.values(props.recipes ?? {}).map((item, i) => (
            <ListItem sx={{ display: "flex", alignItems: "center" }}>
              <ListItemButton
                sx={{ flexGrow: 1 }}
                onClick={() => {
                  onClick({
                    state,
                    setState,
                    item,
                  });
                }}
                key={`${item}-${i}`}
              >
                <ListItemText primary={item.name} />
              </ListItemButton>
              <IconButton
                onClick={() =>
                  openMealCard({
                    ...props,
                    selectedRecipe: item,
                  })
                }
                edge="end"
                aria-label="view"
              >
                <VisibilityIcon />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Box>
  );
}

interface OnClickProps extends StateProps {
  item: Recipe | undefined;
}
export function onClick(props: OnClickProps) {
  const { state, setState, item } = props;
  const stateMenuEntries = Object.entries(state.menu);
  if (stateMenuEntries.length > 0) {
    stateMenuEntries.map(([date, menuItem]) => {
      if (menuItem.selected) {
        setState((prevState: State) => {
          const prevMenu = JSON.parse(JSON.stringify(prevState.menu)) as Record<
            string,
            MenuItem
          >;
          const selectedMealName = state.selectedMealName;
          prevMenu[date].recipe = item;
          prevMenu[date].mealName = selectedMealName;
          prevMenu[date].mealOrder = state.settings
            ? state.settings.meals.indexOf(selectedMealName)
            : (MealNameToOrder[selectedMealName as MealName] ?? 0);
          return {
            ...prevState,
            menu: prevMenu,
            openModals: {
              ...prevState.openModals,
              recipeBook: false,
            },
            selectedRecipe: item,
          };
        });
      }
    });
  } else {
    setState((prevState: State) => {
      return {
        ...prevState,
        selectedRecipe: item,
      };
    });
  }
}
